module.exports = __webpack_public_path__ + "static/media/empty_series_ready.99316c45.svg";